import { Gastos } from "@/shared/interfaces/erp/inventario";
import { create } from "zustand";
import { PaginationState } from "@tanstack/react-table";
import { toast } from "react-toastify";

interface GastosState {
  gastos: Gastos[];
  pagination: PaginationState
  paginatedData: Gastos[]
  openModalGastos: boolean;

  clearSelectedItemsGasto: () => void;

  setOpenModalGastos: (openModalGastos: boolean) => void

  setPagination: (pagination: PaginationState | ((prev: PaginationState) => PaginationState)) => void
  handleEliminarGasto: (id: string) => void
  handleAgregarGasto: (gasto: Gastos) => void
  handleCopiarLista: (gasto: Gastos[]) => void
  handleActualizarGasto: (id: string, nuevosValores: Partial<Gastos>) => void
}

export const useGastos = create<GastosState>((set, get) => ({

  gastos: [],
  pagination: { pageIndex: 0, pageSize: 10 },
  paginatedData: [],
  openModalGastos: false,

  clearSelectedItemsGasto() {
    set(() => {
      return {
        pagination: { pageIndex: 0, pageSize: 10 },
        paginatedData: [],
        gastos: [],

      }
    });
  },
  setOpenModalGastos(openModalGastos) {
    set({ openModalGastos })
  },

  setPagination: (pagination) => {
    set((state) => {
      const newPagination = typeof pagination === "function"
        ? pagination(state.pagination)
        : pagination;
      return {
        pagination: newPagination,
        paginatedData: state.gastos.slice(
          newPagination.pageIndex * newPagination.pageSize,
          (newPagination.pageIndex + 1) * newPagination.pageSize
        )
      }

    })

  },

  handleEliminarGasto(id) {
    set((state) => {
      const gastosFiltrados = state.gastos.filter((gasto) => gasto.id_gasto !== id)
      return {
        gastos: gastosFiltrados,
        paginatedData: gastosFiltrados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        )
      }
    })
  },
  handleCopiarLista(gasto) {
    set((state) => {
      return {
        gastos: gasto,
        paginatedData: gasto.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        )
      }
    })

  },

  handleAgregarGasto: (gasto) => {
    if (get().gastos.some(element => element.codigo === gasto.codigo))
      return toast.info('Gasto previamente agregado.')
    set((state) => {
      const gastosActualizados = [...state.gastos, gasto];
      return {
        gastos: gastosActualizados,
        paginatedData: gastosActualizados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        )
      }
    });
    toast.success('Gasto agregado correctamente.')
  },

  handleActualizarGasto(id, nuevosValores) {
    set((state) => {
      const gastosActualizados = state.gastos.map((gasto) =>
        gasto.id_gasto === id ? { ...gasto, ...nuevosValores } : gasto
      );
      return {
        gastos: gastosActualizados,
        paginatedData: gastosActualizados.slice(
          state.pagination.pageIndex * state.pagination.pageSize,
          (state.pagination.pageIndex + 1) * state.pagination.pageSize
        )
      }
    })
    //toast.success("Gasto actualizado")
  },

}))

